module.exports = __webpack_public_path__ + "static/img/s1.70e3334.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/s1.png
// module id = 1nUg
// module chunks = 0